import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Nav.css';

import Chatbot from '../../Components/Chatbot/Chatbot'

import bright from '../../Media/Nav.Media/bright.png'
import dark from '../../Media/Nav.Media/dark.png'
import spidy_bright from '../../Media/Nav.Media/spidy_bright.png'
import spidy_dark from '../../Media/Nav.Media/spidy_dark.png'
import lang from '../../Media/Nav.Media/lang.png'

const Nav = ({ ShowMessage }) => {
	
	const [isResponsiveNavOpen, setIsResponsiveNavOpen] = useState(false);
	const [isLightMode, setIsLightMode] = useState(() => {return localStorage.getItem('lightMode') === 'true';});
	const toggleMode = () => { const newMode = !isLightMode; setIsLightMode(newMode); localStorage.setItem('lightMode', newMode);};
    const toggleResponsiveNav = () => {setIsResponsiveNavOpen(!isResponsiveNavOpen);};
    const [showChatbot, setShowChatbot] = React.useState(false);
	
	useEffect(() => {document.body.classList.toggle('light-mode', isLightMode);}, [isLightMode]);

	return (
		<>
			<nav>
				<NavLink 
					to='/' 
					onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
					className='brand-link'
				>
					<div className='brand'>
						<span className='yassine'>YASSINE</span>
						<span className='bazgour'>BAZGOUR</span>
					</div>
				</NavLink>

				<div className='nav-links-container'>
					<NavLink 
						to='/' 
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
						className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
					>
						Home
					</NavLink>
					<NavLink 
						to='/Projects' 
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
						className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
					>
						Projects
					</NavLink>
					<NavLink  
						to='/Research' 
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
						className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
					>
						Research
					</NavLink>
					<NavLink  
						to='/Certificates'
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
						className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
					>
						Certificates
					</NavLink>
					<NavLink
						to='/Events'
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
						className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
					>
						Events
					</NavLink>
					<NavLink  
						to='/Blog'
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
						className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
					>
						Blog
					</NavLink>
					<NavLink 
						to='/About' 
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} 
						className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
					>
						About
					</NavLink>
				</div>

				<div className='contact-mode'>
					<img 
						// onClick={() => {console.log("hi")}}
						onClick={toggleMode}
						className='mode-icon'
						src={`${isLightMode ? dark : bright}`}
						alt='Light Mode'
					></img>
					<img 
						onClick={() => setShowChatbot(!showChatbot)}
						className='spidy-icon'
						src={`${isLightMode ? spidy_bright : spidy_dark}`}
						alt='Assistant Spidy'
					></img>
					<img 
						onClick={() => ShowMessage('The language selector is not available now. Working on it!', 'Warning')}
						className='lang-icon'
						src={lang}
						alt='Change Language'
					></img>
					{/* {showLangDropdown && (
						<div className='lang-dropdown'>
							<button onClick={() => {setLanguage('en'); setShowLangDropdown(false);}}> en English</button>
							<button onClick={() => {setLanguage('fr'); setShowLangDropdown(false);}}> 🇫🇷 Français</button>
							<button onClick={() => {setLanguage('de'); setShowLangDropdown(false);}}> 🇩🇪 Deutsch</button>
							<button onClick={() => {setLanguage('ar'); setShowLangDropdown(false);}}> 🇲🇦 العربية</button>
						</div>
					)} */}
					<NavLink 
						to='/Contact' 
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
						className={({isActive}) => isActive ? 'contact-link active-contact-link' : 'contact-link'}
					>
						<button className='contact'>
							<i className='far fa-envelope'></i>
							Contact
						</button>
					</NavLink>
				</div>

				<div 
					onClick={toggleResponsiveNav}
					className='settings'
				>
					<div className='settings-line'></div>
					<div className='settings-line'></div>
					<div className='settings-line'></div>
				</div>

				<div 
					className='responsive-nav'
					style={{ display: isResponsiveNavOpen ? 'flex' : 'none' }}
				>
					<div className='responsive-nav-header'>
						<NavLink 
							to='/' 
							onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
							className='brand-link'
						>
							<div className='brand'>
								<span className='yassine'>YASSINE</span>
								<span className='bazgour'>BAZGOUR</span>
							</div>
						</NavLink>
						<i 
							onClick={toggleResponsiveNav}
							className='close-res-nav fa fa-times'
						></i>
					</div>

					<div className='responsive-nav-links-container'>
						<div className='responsive-nav-links-container-row'>
							<div className='responsive-nav-link-container'>
								<NavLink 
									to='/' 
									onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' }); toggleResponsiveNav()}} 
									className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
								>
									Home
								</NavLink>
							</div>
							<div className='responsive-nav-link-container'>
								<NavLink 
									to='/Projects' 
									onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' }); toggleResponsiveNav()}} 
									className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
								>
									Projects
								</NavLink>
							</div>
						</div>
						<div className='responsive-nav-links-container-row'>
							<div className='responsive-nav-link-container'>
								<NavLink  
									to='/Research' 
									onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' }); toggleResponsiveNav()}} 
									className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
								>
									Research
								</NavLink>
							</div>
							<div className='responsive-nav-link-container'>
								<NavLink 
									to='/Certificates'
									onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' }); toggleResponsiveNav()}} 
									className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
								>
									Certificates
								</NavLink>
							</div>
						</div>
						<div className='responsive-nav-links-container-row'>
							<div className='responsive-nav-link-container'>
								<NavLink 
									to='/Events'
									onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' }); toggleResponsiveNav()}} 
									className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
								>
									Events
								</NavLink>
							</div>
							<div className='responsive-nav-link-container'>
								<NavLink
									to='/Blog'
									onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' }); toggleResponsiveNav()}} 
									className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
								>
									Blog
								</NavLink>
							</div>
						</div>
						<div className='responsive-nav-links-container-row'>
							<div className='responsive-nav-link-container'>
								<NavLink 
									to='/About' 
									onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' }); toggleResponsiveNav()}} 
									className={({ isActive }) => isActive ? 'nav-link active-link' : 'nav-link'}
								>
									About
								</NavLink>
							</div>
						</div>
					</div>

					<div className='responsive-contact-mode'>
						<div className='nav-icons'>
							<img 
								onClick={toggleMode}
								src={`${isLightMode ? dark : bright}`}
								alt='Light Mode'
								className='mode-icon'
							></img>
							<img 
								onClick={() => {setShowChatbot(!showChatbot); toggleResponsiveNav()}}
								className='fa fa-robot spidy-icon'
								src={`${isLightMode ? spidy_bright : spidy_dark}`}
								alt='Assistant Spidy'
							></img>
							<img 
								onClick={() => ShowMessage('The language selector is not available now. Working on it!', 'Warning')}
								className='fa-solid fa-language lang-icon'
								src={lang}
								alt='Change Language'
							></img>	
						</div>
						<NavLink 
							to='/Contact' 
							onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' }); toggleResponsiveNav()}}
							className={({isActive}) => isActive ? 'contact-link active-contact-link' : 'contact-link'}
						>
							<button className='contact responsive-contact'>
								<i className='far fa-envelope'></i>
								Contact
							</button>
						</NavLink>
					</div>
				</div>
			</nav>

			<Chatbot isVisible={showChatbot} onClose={() => setShowChatbot(false)} />
		</>

	);
};

export default Nav;
